export const dateHandler = {
    toInputFormat: (date) => {
        if (date === null) {
            return '';
        }
        if (date instanceof Date) {
            return date.toISOString().split('T')[0];
        }

        return date.split('T')[0].split(' ')[0];
    },
    toDisplayFormat: (date) => {
        if (date === null) {
            return '';
        }
        if (date instanceof Date) {
            return date.toLocaleDateString();
        }
        const split = date.split(' ')[0].split('-');
        const year = split[0];
        const month = split[1];
        const day = split[2];
        return `${month}/${day}/${year}`;
    },
    toSubmitFormat: (date) => {
        if (date === null || date === '' || date === undefined) {
            return null;
        }
        return dateHandler.toZeroHoursFormat(date).toISOString().slice(0, 19).replace('T', ' ').split(' ')[0];
    },
    toZeroHoursFormat: (date) => {
        if (date === null) {
            return null;
        }
        if (date instanceof Date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
        }
        const split = date.split('-');
        const year = parseInt(split[0]);
        const month = parseInt(split[1]);
        const day = parseInt(split[2]);
        
        return new Date(year, month - 1, day, 0, 0, 0, 0);
    },
    toNearestValidDate: (date) => {
        if (!date) {
            return null;
        }

        if (typeof date === 'string') {
            const year = parseInt(date.split('-')[0]);
            const month = parseInt(date.split('-')[1]) - 1;
            const day = parseInt(date.split('-')[2]);
            date = new Date(year, month, day);
        } else if (typeof date === 'number') {
            date = new Date(date);
        } else if (!(date instanceof Date)) {
            console.warn('Invalid date type provided:', date);
            return null;
        }

        if (isNaN(date.getTime())) {
            console.warn('Invalid date provided:', date);
            return null;
        }
    
        const month = date.getMonth();
        const year = date.getFullYear();
        const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
        const day = Math.min(date.getDate(), lastDayOfMonth);
        return new Date(year, month, day);
    }
}

export const getUTCTimetamp = (date) => {
    return Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 1000);
}